import { CSSInterpolation } from '@mui/material';

import {
  tableBlack,
  tableBorderColor,
  tableWhite,
} from '../variables/variables';

export const tableContainerInterpolation: CSSInterpolation = {
  position: 'relative',
  height: '100%',
  width: '100%',
  margin: 'auto',
  overflowX: 'hidden',
  padding: 0,

  '.table-footer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '36px',

    '&.no-bulk': {
      justifyContent: 'flex-end',
    },

    '.bulk-actions-select': {
      color: tableBlack,
      backgroundColor: tableWhite,
      border: `1px solid ${tableBorderColor}`,
      borderRadius: '5px',
      width: '264px',
      fontSize: '14px',

      '& fieldset': {
        border: 'none',
        outline: 'none',
      },

      '.bulk-actions-list': {
        padding: '6px 16px',
        fontSize: '14px',
      },

      svg: {
        fill: tableBlack,
      },

      '&:focus': {
        backgroundColor: tableWhite,
        border: `1px solid ${tableBorderColor}`,
        borderRadius: '5px',
      },
    },
  },
};
